import styled from 'styled-components';

export const Container = styled.div`
  /* Medidas do protótipo: busca com rótulo, tabela em card, células como texto até o foco. */
  .sheet-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;

    .material-icons-outlined {
      font-size: 18px;
    }
  }

  .table-tools {
    display: grid;
    grid-template-columns: minmax(300px, 460px) auto 1fr;
    align-items: end;
    gap: 16px;
    margin: 0 0 12px;

    &.with-lot-filter {
      grid-template-columns: minmax(300px, 460px) 180px auto 1fr;
    }
  }

  .item-search,
  .lot-filter {
    display: flex;
    flex-direction: column;
    gap: 5px;
    color: #21354a;
    font-size: 13px;
    font-weight: 500;
  }

  .item-search > div {
    height: 40px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0 10px;
    gap: 8px;

    &:focus-within {
      border-color: #80bdff;
      box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
    }

    .material-icons-outlined {
      color: #6c757d;
      font-size: 20px;
    }

    input {
      border: 0;
      outline: 0;
      min-width: 0;
      flex: 1;
      font-weight: 400;
    }
  }

  .lot-filter select {
    height: 40px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 0 8px;
    background: #fff;
    font-weight: 400;
  }

  .selected-filter {
    height: 40px;
    display: flex;
    align-items: center;
    gap: 7px;
    white-space: nowrap;
    color: #495057;
    cursor: pointer;

    input {
      width: 16px;
      height: 16px;
    }
  }

  .selected-counter {
    color: #21354a;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
  }

  .table-card {
    border: 1px solid #dee2e6;
    border-radius: 8px;
    overflow: hidden;
  }

  .table-scroll {
    overflow-x: auto;
  }

  table.proposal-items-table {
    width: 100%;
    margin: 0;
    border-collapse: collapse;

    th {
      font-size: 14px;
      font-weight: 600;
      color: #21354a;
      background: #f8f9fa;
      height: 48px;
      padding: 8px;
      border-bottom: 1px solid #dee2e6;
      white-space: nowrap;
      vertical-align: middle;
    }

    td {
      padding: 6px 5px;
      border-bottom: 1px solid #dee2e6;
      color: #495057;
      height: 56px;
      font-size: 14px;
      vertical-align: middle;
    }

    td input.form-control {
      min-width: 70px;
      border: 1px solid transparent;
      background: transparent;
      border-radius: 4px;
      padding: 7px 6px;
      height: auto;
      box-shadow: none;

      &:hover {
        border-color: #ced4da;
        background: #fff;
      }

      &:focus {
        border-color: #80bdff;
        box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
        background: #fff;
      }
    }

    .select-column {
      width: 120px;
    }

    .select-cell {
      text-align: center;
      width: 56px;

      input {
        width: 16px;
        height: 16px;
      }
    }

    tr.selected-row td {
      background: #edf5ff;
    }
  }

  .money-input {
    display: flex;
    align-items: center;
    white-space: nowrap;
    gap: 2px;

    > span {
      font-size: 13px;
    }

    input::placeholder {
      color: #adb5bd;
      opacity: 1;
    }
  }

  .table-bottom {
    min-height: 62px;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 16px;
    align-items: center;
    padding-top: 12px;
  }

  .pagination-summary {
    color: #6c757d;
    font-size: 13px;
  }

  .pagination {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 0;

    > span {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    button {
      min-width: 34px;
      height: 34px;
      border: 1px solid #dee2e6;
      border-radius: 4px;
      background: #fff;
      color: #495057;
      display: inline-flex;
      align-items: center;
      justify-content: center;

      &:hover:not(:disabled) {
        background: #f8f9fa;
        border-color: #ced4da;
      }

      &[aria-current='page'] {
        background: #007bff;
        border-color: #007bff;
        color: #fff;
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      .material-icons-outlined {
        font-size: 20px;
      }
    }
  }

  .pagination-ellipsis {
    padding: 0 3px;
    color: #6c757d;
  }

  .proposal-total {
    justify-self: end;
    text-align: right;

    small,
    strong {
      display: block;
    }

    small {
      font-size: 13px;
      color: #6c757d;
    }

    strong {
      font-size: 20px;
      color: #21354a;
    }
  }

  .header-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .header-icon {
    font-size: 14px;
    color: #6c757d;
  }

  .proposal-items-col-cliente {
    position: relative;
  }

  .header-action {
    position: relative;
    display: inline-block;
    margin-left: 2px;
    vertical-align: middle;
  }

  .head-menu {
    opacity: 0;
    border: 0;
    background: none;
    padding: 3px;
    line-height: 1;

    .material-icons-outlined {
      font-size: 16px;
      color: #6c757d;
    }

    &:focus,
    &[aria-expanded='true'] {
      opacity: 1;
    }
  }

  th:hover .head-menu {
    opacity: 1;
  }

  .head-menu-list {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 20;
    min-width: 150px;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    padding: 4px 0;

    button {
      border: 0;
      background: transparent;
      text-align: left;
      padding: 6px 12px;
      font-weight: 400;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 6px;

      &:hover {
        background: #f8f9fa;
      }

      .material-icons-outlined {
        font-size: 16px;
      }
    }
  }

  .table-add-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 12px;
    padding: 8px 12px;
    border-top: 1px solid #dee2e6;
    background: #f8f9fa;

    .btn {
      display: inline-flex;
      align-items: center;
      gap: 4px;
    }

    .material-icons-outlined {
      font-size: 18px;
    }

    span {
      color: #6c757d;
      font-size: 13px;
    }
  }

  .proposal-items-search {
    max-width: 260px;
  }

  .proposal-items-lote {
    max-width: 160px;
  }

  .proposal-items-table {
    th {
      white-space: nowrap;
      font-size: 13px;
      color: ${(props) => props.theme.$gray700};
    }

    td {
      vertical-align: middle;
      font-size: 13px;
    }

    .proposal-items-desc {
      min-width: 220px;
      max-width: 360px;
      white-space: normal;
      word-break: break-word;
    }

    .proposal-items-price {
      max-width: 120px;
    }

    .proposal-items-total {
      white-space: nowrap;
      font-weight: 600;
    }
  }

  .proposal-items-counter {
    color: ${(props) => props.theme.$gray700};
    font-weight: 600;
  }

  .proposal-items-grand-total {
    color: ${(props) => props.theme.$dark};
  }

  .proposal-items-exigida-icon {
    font-size: 14px;
    vertical-align: text-bottom;
    color: ${(props) => props.theme.$warning};
  }

  .proposal-items-obrigatorio {
    input,
    input.form-control {
      border-color: ${(props) => props.theme.$danger} !important;
      background: #fff !important;
    }
  }

  .proposal-items-lote-row {
    background: ${(props) => props.theme.$gray100 || '#f8f9fa'};
    font-weight: 600;
  }

  .proposal-items-tag {
    font-weight: 500;
    border: 1px solid ${(props) => props.theme.$gray300};
  }

  .proposal-items-col-acao {
    font-size: 15px;
    vertical-align: middle;
  }

  .proposal-items-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1060;
  }

  .proposal-items-modal {
    max-width: 440px;
    width: 90%;
  }

  .proposal-items-form {
    border-color: ${(props) => props.theme.$gray300};
  }

  .proposal-items-file-input {
    display: none;
  }

  .proposal-items-spreadsheet-hint {
    margin-top: -0.5rem;
  }

  .proposal-items-import-ignoradas {
    padding-left: 1.1rem;
  }

  .proposal-items-preco-competitivo {
    white-space: nowrap;
    color: ${(props) => props.theme.$primary || props.theme.$gray700};
  }

  .proposal-items-preco-competitivo-icon {
    font-size: 15px;
    vertical-align: text-bottom;
  }

  .proposal-items-competitivo-bloco h6 {
    font-size: 14px;
    font-weight: 600;
    color: ${(props) => props.theme.$dark};
  }

  .proposal-items-competitivo-faixa {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .proposal-items-faixa-item {
    padding: 6px 10px;
    border-radius: 4px;
    font-size: 13px;
    border: 1px solid ${(props) => props.theme.$gray300};
    color: ${(props) => props.theme.$gray700};

    &.ativa {
      border-color: ${(props) => props.theme.$primary || props.theme.$dark};
      font-weight: 600;
      color: ${(props) => props.theme.$dark};
    }
  }
`;
